import React, { useCallback, useState } from 'react';
import SurveyQuestionContainer from './surveyQuestionContainer';
import { axiosRequestData } from '../../../helpers/axios';
import { AxiosResponse } from 'axios';
import { getWsCloseFlag } from '../../../helpers/utils';

type SurveyContainerProps = {
    setModalIsOpen: (b: boolean) => void;
};
async function addWsCloseFlag(): Promise<AxiosResponse<any, any>> {
    const wsClose = getWsCloseFlag();
    const data = { ws_close: wsClose + 1 };
    return axiosRequestData('POST', '/wp-json/pg/v1/user/addflag', data);
};

const SurveyContainer: React.FC<SurveyContainerProps> = ({ setModalIsOpen }) => {
    const [currentQuestionId, setCurrentQuestionId] = useState<number>(0);
    const [answerHistory, setAnswerHistory] = useState<
        { questionId: number; answer: string }[]
    >([]);

    const closeSurvey = useCallback(() => {
        setModalIsOpen(false);
        window.pgPopupActive = null;
        addWsCloseFlag()
            .then(() => {})
            .catch(e => console.log('Unexpected error closing survey.', e));
    }, [setModalIsOpen]);

    return (
        <SurveyQuestionContainer
            questionId={currentQuestionId}
            setQuestionId={setCurrentQuestionId}
            closeSurvey={closeSurvey}
            answerHistory={answerHistory}
            setAnswerHistory={setAnswerHistory}
        />
    );
};

export default SurveyContainer;